module.exports = __webpack_public_path__ + "static/media/no-items-yet.3661ecaa.png";